const settings = {
    firstNameInput: '',
    lastNameInput: '',
    emailInput: '',
    formId: '',
    errorMessages: null,
    isLeisureNewsletterInput: false,
    isCorporateNewsletterInput: false,
    isBrokerNewsletterInput: false,
    isAgentNewsletterInput: false
};

const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const newsletterErrorsId = 'newsletter-errors';
const hiddenClass = 'hidden';

const validateCheckboxes = () => {
    const checkboxArray = Array.from(document.getElementsByTagName('ergo-checkbox'));
    const atLeastOneChecked = checkboxArray.some(checkbox => checkbox.checked);
    const isValid = atLeastOneChecked || !checkboxArray.length;

    if (isValid) {
        hideCheckboxErrorMessage();
    } else {
        showCheckboxErrorMessage();
    }
    return isValid;
}

const hideCheckboxErrorMessage = () => {
    const errors = document.getElementById(newsletterErrorsId);
    if (errors.classList.contains(hiddenClass)) {
        return;
    }
    errors.classList.add(hiddenClass);
}

const showCheckboxErrorMessage = () => {
    const errors = document.getElementById(newsletterErrorsId);
    if (errors.classList.contains(hiddenClass)) {
        errors.classList.remove(hiddenClass);
    }
}

const validate = (values) => {
    const isEmailValid = (email) => emailRegexp.test(email);

    return {
        [settings.firstNameInput]: !values[settings.firstNameInput].length && settings.errorMessages.requiredFieldErrorMessage,
        [settings.lastNameInput]: !values[settings.lastNameInput].length && settings.errorMessages.requiredFieldErrorMessage,
        [settings.emailInput]: !values[settings.emailInput].length 
            ? settings.errorMessages.requiredFieldErrorMessage
            : !isEmailValid(values[settings.emailInput]) && settings.errorMessages.emailPatternErrorMessage
    };
};

const submitButton = () => document.querySelector(`#newsletter-signup-trigger-${settings.formId}`);
const successMessage = () => document.querySelector(`#newsletter-signup-message-${settings.formId}`);
const newsletterForm = () => document.querySelector(`#newsletter-singup-form-${settings.formId}`);

const handleSuccess = (response) => {
    if(response){
        successMessage().style.display = 'block';
    }
}

const submit = (form, data) => {

    if (!validateCheckboxes()) {
        return;
    }

    submitButton().disabled = true;

    const jsonData = {
        FirstName: data.values[settings.firstNameInput],
        LastName: data.values[settings.lastNameInput],
        Email: data.values[settings.emailInput],
        IsLeisureNewsletter: data.values[settings.isLeisureNewsletterInput] === 'true',
        IsCorporateNewsletter: data.values[settings.isCorporateNewsletterInput] === 'true',
        IsBrokerNewsletter: data.values[settings.isBrokerNewsletterInput] === 'true',
        IsAgentNewsletter: data.values[settings.isAgentNewsletterInput] === 'true'
    }
    
    fetch(form.attributes['action'].value, {
        method: form.attributes['method'].value,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(jsonData)
    }).then(response => response.json().then(r => handleSuccess(r)))
    .catch(e => console.error(e))
    .finally(()=> {
        submitButton().disabled = false;
    });

    form.setSubmitted();
}

const init = (firstNameInputName, lastNameInputName, emailInputName, errorMessages, formId,
    isLeisureNewsletterName, isCorporateNewsletterName, isBrokerNewsletterName, isAgentNewsletterName) => {
    settings.firstNameInput = firstNameInputName;
    settings.lastNameInput = lastNameInputName;
    settings.emailInput = emailInputName;
    settings.formId = formId;
    settings.errorMessages = errorMessages;
    settings.isLeisureNewsletterInput = isLeisureNewsletterName;
    settings.isCorporateNewsletterInput = isCorporateNewsletterName;
    settings.isBrokerNewsletterInput = isBrokerNewsletterName;
    settings.isAgentNewsletterInput = isAgentNewsletterName;

    const form = newsletterForm();
    form.validation = (values) => validate(values);

    form.addEventListener('ergoFormSubmit',
        (e) => {
            successMessage().style.display = 'none';
            
            const submittedForm = e.target;
            const submittedFormState = e.detail;

            submit(submittedForm, submittedFormState);
        });
    const checkboxes = document.getElementsByTagName('ergo-checkbox');
    for (var checkbox of checkboxes)
    {
        checkbox.addEventListener('ergoChange', () => {
            validateCheckboxes();
        });
    }
    }

const NewsletterSignUp = {
    init
}

window.NewsletterSignUp = {
    init: NewsletterSignUp.init
}

export default NewsletterSignUp;